import { useEffect, useState } from 'react';
import LevelService from '../../../../services/level_service';
import Deletes from './Deletes';
import Updates from './Updates';
import Images from './Images';

const Levels = (props) => {
  const [levels, setLevels] = useState([]);
    
  const loadLevels = async () => {
    try {
      props.setLoading(true);
      const levelsData = await LevelService.getAll()
      if (props.logout(levelsData)) return;
      const formatted = (levelsData || []).map(level => ({
        ...level,
        EquivalentActivities: level.EquivalentActivities
        ? level.EquivalentActivities.split('-').map(a => a.trim())
          .map((text, index) => ({
            Id: `${level.Id}-${index}`,
            text
          }))
        : []
      }));
      setLevels(formatted || []);
    } catch (e) {
      props.message((e?.message || e), "error");
    } finally {
      props.setLoading(false);
    }
  };

  useEffect(() => {loadLevels()}, []);

  const handleAddLevel = async () => {
    const lostAccess = await props.losesAccess?.();
    if (lostAccess) return;
    setLevels(prev => [
      ...prev,
      {
        Id: `temp-${Date.now()}`,
        Insignia: '',
        Minimum: 0,
        Maximum: 0,
        EquivalentActivities: []
      }
    ]);
  };

  const updates = Updates({
    losesAccess: props.losesAccess,
    message: props.message,
    setLoading: props.setLoading,
    logout: props.logout,
    levels,
    loadLevels
  });

  const deletes = Deletes({
    losesAccess: props.losesAccess,
    message: props.message,
    setLoading: props.setLoading,
    logout: props.logout,
    levels,
    setLevels
  });

  const images = Images({
    losesAccess: props.losesAccess,
    message: props.message,
    logout: props.logout
  })

  return {
    ...deletes,
    ...updates,
    ...images,
    levels,
    setLevels,
    handleAddLevel
  }  
}

export default Levels;
